import faker from 'faker'
import moment from 'moment'
import hres81xLabels from 'assets/labels/hres81x'

export const mocker = {
  labels () {
    return {
      labels: hres81xLabels
    }
  },
  index () {
    let amtinc = {
      '1': Math.random() * 100000,
      '2': Math.random() * 100000,
      '3': Math.random() * 100000
    }
    let amtpay = {
      '1': Math.random() * 100000,
      '2': Math.random() * 100000,
      '3': Math.random() * 100000
    }
    let mockIndex = {
      'block_index': {
        'codempid': faker.lorem.word(),
        'desc_codempid': faker.lorem.word(),
        'position': faker.lorem.word(),
        'department': faker.lorem.word(),
        'paymentdate': moment().format('DD/MM/YYYY'),
        'acc_id': Math.random() * 10000000000000,
        'periodpy': moment().format('DD/MM/YYYY') + ' - ' + moment().format('DD/MM/YYYY'),
        'periodal': moment().format('DD/MM/YYYY') + ' - ' + moment().format('DD/MM/YYYY')
      },
      'block': {
        'amtinc': {
          '1': amtinc[1],
          '2': amtinc[2],
          '3': amtinc[3]
        },
        'amtinc_e': {
          '1': amtinc[1],
          '2': amtinc[2],
          '3': amtinc[3]
        },
        'codinc': {
          '1': 'เงินเดือน/ค่าแรง',
          '2': faker.lorem.word(),
          '3': faker.lorem.word()
        }
      },
      'block1': {
        'amtpay': {
          '1': amtpay[1],
          '2': amtpay[2],
          '3': amtpay[3]
        },
        'amtpay_e': {
          '1': amtpay[1],
          '2': amtpay[2],
          '3': amtpay[3]
        },
        'codded': {
          '1': 'ภาษีหัก ณ ที่จ่าย',
          '2': faker.lorem.word(),
          '3': faker.lorem.word()
        }
      },
      'block2': {
        'qtysmot': {
          '1': ':',
          '2': '2:00',
          '3': '3:00'
        },
        'rteot': {
          '1': '1',
          '2': '1.5',
          '3': '2'
        },
        'desot': {
          '1': 'O.T',
          '2': 'O.T',
          '3': 'O.T'
        },
        'hrs': {
          '1': 'ชม.',
          '2': 'ชม.',
          '3': 'ชม.'
        }
      },
      'block3': {
        'suminc': amtinc[1] + amtinc[2] + amtinc[3],
        'sumpay': amtpay[1] + amtpay[2] + amtpay[3],
        'sumnet': amtinc[1] + amtinc[2] + amtinc[3] - (amtpay[1] + amtpay[2] + amtpay[3]),
        'sumnet_e': amtinc[1] + amtinc[2] + amtinc[3] - (amtpay[1] + amtpay[2] + amtpay[3]),
        'day1': 'วัน',
        'day2': 'วัน',
        'vacation': '',
        'qtywrk': '31',
        'salary': amtinc[1],
        'amtcalt': Math.random() * 100000,
        'amttax': amtpay[1],
        'amtsoc': '0',
        'amtpf': '5250'
      },
      'msg_error': ''
    }
    // faker.lorem.word()
    return mockIndex
  },
  numperiod () {
    return '1'
  },
  login () {
    return 'success'
  }
}



// WEBPACK FOOTER //
// ./src/api/hres81x/mocker.js